// Theme Color Replacer Utility
// This utility helps replace hardcoded theme colors with CSS variables

export const replaceThemeColors = () => {
  // Function to replace inline styles
  const replaceInlineStyles = () => {
    const elements = document.querySelectorAll('[style*="rgb(63, 14, 64)"], [style*="#3f0e40"], [style*="#3F0E40"], [style*="stroke: #000"], [style*="stroke:#000"]');
    
    elements.forEach(element => {
      const style = element.getAttribute('style');
      if (style) {
        let newStyle = style
          .replace(/rgb\(63,\s*14,\s*64\)/g, 'var(--primary-color)')
          .replace(/#3f0e40/g, 'var(--primary-color-hex)')  // 3f0e40 is the color of the primary color
          .replace(/#3F0E40/g, 'var(--primary-color-hex)')  // 3F0E40 is the color of the primary color
          .replace(/stroke:\s*#000/g, 'stroke: var(--stroke-color)')
          .replace(/stroke:\s*#000/g, 'stroke: var(--stroke-color)');
        
        element.setAttribute('style', newStyle);
      }
    });
  };

  // Function to replace SVG fill attributes
  const replaceSVGFills = () => {
    const svgElements = document.querySelectorAll('svg[fill="#3f0e40"], svg[fill="#3F0E40"]');
    const pathElements = document.querySelectorAll('path[fill="#3f0e40"], path[fill="#3F0E40"]');
    const rectElements = document.querySelectorAll('rect[fill="#3f0e40"], rect[fill="#3F0E40"]');
    
    [...svgElements, ...pathElements, ...rectElements].forEach(element => {
      element.setAttribute('fill', 'var(--primary-color-hex)');
    });
  };

  // Function to replace SVG stroke attributes
  const replaceSVGStrokes = () => {
    const strokeElements = document.querySelectorAll('svg[stroke="#000"], path[stroke="#000"], line[stroke="#000"], rect[stroke="#000"], circle[stroke="#000"], polygon[stroke="#000"], polyline[stroke="#000"]');
    
    strokeElements.forEach(element => {
      element.setAttribute('stroke', 'var(--stroke-color)');
    });
  };

  // Function to replace color attributes
  const replaceColorAttributes = () => {
    const colorElements = document.querySelectorAll('[color="#3f0e40"], [color="#3F0E40"]');
    const bgColorElements = document.querySelectorAll('[background-color="#3f0e40"], [background-color="#3F0E40"]');
    const strokeElements = document.querySelectorAll('[stroke="#000"]');
    
    [...colorElements, ...bgColorElements].forEach(element => {
      const attr = element.hasAttribute('color') ? 'color' : 'background-color';
      element.setAttribute(attr, 'var(--primary-color-hex)');
    });

    strokeElements.forEach(element => {
      element.setAttribute('stroke', 'var(--stroke-color)');
    });
  };

  // Run all replacements
  replaceInlineStyles();
  replaceSVGFills();
  replaceSVGStrokes();
  replaceColorAttributes();
};

// Auto-run when DOM is ready
if (typeof document !== 'undefined') {
  document.addEventListener('DOMContentLoaded', replaceThemeColors);
  
  // Also run when theme changes
  document.addEventListener('theme-changed', replaceThemeColors);
}

export default replaceThemeColors; 